import { ReactElement } from "react"

enum EAvatarFallbackVariant {
    BlueColored = "blueColored",
    DarkBlueImage = "DarkBlueImage",
    /**
      @deprecated not supported with current palette
     */
    GrayColored = "grayColored"
}

enum EAvatarSize {
    _25 = 25,
    _30 = 30,
    _35 = 35,
    _40 = 40,
    _45 = 45,
    _50 = 50,
    _60 = 60,
    _65 = 65,
    _85 = 85,
    _90 = 90,
    _155 = 155
}

type TAvatarListUser = {
    id: number
    firstName: string
    lastName: string
    photo?: string | null
    isExtraParty?: boolean
    isGuest?: boolean
}

type TAvatarProps = {
    url?: string | null
    size?: EAvatarSize
    alt?: string
    userData?: { firstName?: string; lastName?: string }
    isCurrentUser?: boolean
    isGuest?: boolean
    isExtraParty?: boolean
    isAccessible?: boolean
    isLettered?: boolean
    isRestCounter?: boolean
    fallbackVariant?: EAvatarFallbackVariant
    className?: string
    renderIcon?(): ReactElement
}

export type { TAvatarProps, TAvatarListUser }
export { EAvatarSize, EAvatarFallbackVariant }
